export class FieldSectionDto {
  public section: string;
  public fields: string[];
}
